import { useOktaAuth } from '@okta/okta-react';

export const useToken = () => {
  const { authState } = useOktaAuth();
  return authState?.accessToken?.accessToken || '';
};
